import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BaseApiService } from '../base-api.service';
import { CategoryPipe } from './../category.pipe';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ExcelServiceService } from '../excel-service.service';
@Component({

  selector: 'app-view-master',
  templateUrl: './view-master.component.html',
  styleUrls: ['./view-master.component.css'],


})
export class ViewMasterComponent implements OnInit {
  @ViewChild('form') form;
  selectedCategory: string;
  selectedCircularId: String;
  selectedCircularName: String;
  private data: Array<any> = [];
  private data_NSD: Array<any> = [];
  private data_EW: Array<any> = [];
  private data_WAR: Array<any> = [];
  private data_AMC_GOLD: Array<any> = [];
  private data_AMC_SILVER: Array<any> = [];
  private data_PROTECT_PLUS: Array<any> = [];
  private data_AMC_P2P: Array<any> = [];
  private data_CIRCULAR: Array<any> = [];
  private data_CIRCULAR_DOWNLOAD: Array<any> = [];
  private data_SCH_LABOUR: Array<any> = [];
  private data_SCH_PART: Array<any> = [];
  private data_EST_LABOUR: Array<any> = [];
  private data_EST_PART: Array<any> = [];
  private data_USER_POSITION: Array<any> = [];
  files: FileList;
  constructor(private router: Router, private baseAPI: BaseApiService, private spinnerService: Ng4LoadingSpinnerService, public excel: ExcelServiceService) {

    var token = localStorage.getItem('token');
    if (token == undefined || token === '') {
      this.router.navigate(['/login']);
    }
    this.length = this.data.length;
    this.length_NSD = this.data_NSD.length;
    this.length_EW = this.data_EW.length;
    this.length_WAR = this.data_EW.length;
    this.length_AMC_GOLD = this.data_AMC_GOLD.length;
    this.length_AMC_P2P = this.data_AMC_P2P.length;
    this.length_CIRCULAR = this.data_CIRCULAR.length;
    this.length_SCH_LABOUR = this.data_SCH_LABOUR.length;
    this.length_SCH_PART = this.data_SCH_PART.length;
    this.length_EST_LABOUR = this.data_EST_LABOUR.length;
    this.length_EST_PART = this.data_EST_PART.length;
    this.length_USER_POSITION = this.data_USER_POSITION.length;
  }

  uploadMaster() {
    this.router.navigate(['/uploadMaster']);
  }
  dashboard() {
    this.router.navigate(['/dashboard']);
  }
  notification() {
    this.router.navigate(['/notification']);
  }
  userPositions() {
    this.router.navigate(['/userPosition']);
  }
  category = [
    { index: '1', viewValue: 'Probing Data' },
    { index: '2', viewValue: 'Circular Data' },
    { index: '3', viewValue: 'Warranty & Service schedule Data' },
    { index: '4', viewValue: 'Product estimate EW' },
    { index: '5', viewValue: 'Product estimate AMC Silver' },
    { index: '6', viewValue: 'Product estimate AMC Gold' },
    { index: '7', viewValue: 'Product estimate AMC P2P' },
    { index: '8', viewValue: 'NSD Data' },
    { index: '9', viewValue: 'Schedule service estimator Labour data ' },
    { index: '10', viewValue: 'Schedule service estimator Part data ' },
    { index: '11', viewValue: 'Add on Job estimate Labour data' },
    { index: '12', viewValue: 'Add on Job estimate Part data' },
    { index: '13', viewValue: 'User Position' },
    { index: '14', viewValue: 'Product estimate AMC Protect Plus' }


  ];
  downloadAsExcelFile() {
    if (this.selectedCategory === this.category[0].viewValue) {
      this.excel.exportAsExcelFile(this.data, 'ProbingQuestionsMaster');
    }
    if (this.selectedCategory === this.category[1].viewValue) {

      this.spinnerService.show();
      this.downloadCircularListApi(0, 1, false);


    }

    else if (this.selectedCategory === this.category[2].viewValue) {
      this.excel.exportAsExcelFile(this.data_WAR, 'warranty_master');
    }
    else if (this.selectedCategory === this.category[3].viewValue) {
      this.excel.exportAsExcelFile(this.data_EW, 'EW_master');
    }
    else if (this.selectedCategory === this.category[4].viewValue) {
      this.excel.exportAsExcelFile(this.data_AMC_SILVER, 'AMC_silver');
    }
    else if (this.selectedCategory === this.category[5].viewValue) {
      this.excel.exportAsExcelFile(this.data_AMC_GOLD, 'AMC_gold');
    }

    else if (this.selectedCategory === this.category[6].viewValue) {
      this.excel.exportAsExcelFile(this.data_AMC_P2P, 'AMC_p2p');
    }
    else if (this.selectedCategory === this.category[7].viewValue) {
      this.excel.exportAsExcelFile(this.data_NSD, 'NSD_master');
    }
    else if (this.selectedCategory === this.category[8].viewValue) {
      this.excel.exportAsExcelFile(this.data_SCH_LABOUR, 'sche_service_labour');
    }
    else if (this.selectedCategory === this.category[9].viewValue) {
      this.excel.exportAsExcelFile(this.data_SCH_PART, 'sche_service_parts');
    }
    else if (this.selectedCategory === this.category[10].viewValue) {
      this.excel.exportAsExcelFile(this.data_EST_LABOUR, 'std_estimate_labour');
    }
    else if (this.selectedCategory === this.category[11].viewValue) {
      this.excel.exportAsExcelFile(this.data_EST_PART, 'std_estimate_parts');
    }
    else if (this.selectedCategory === this.category[13].viewValue) {      
      this.excel.exportAsExcelFile(this.data_PROTECT_PLUS, 'protect_plus');
    }
    

  }
  listClick(event: any, newValue) {
    event.preventDefault();
    // console.log(newValue);
    this.selectedCategory = newValue;

    if (this.selectedCategory === this.category[0].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callGetProbingListApi(0, 1, false);
    }

    else if (this.selectedCategory === this.category[1].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callCircularListApi(0, 1, false);

    }

    else if (this.selectedCategory === this.category[2].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callWARListApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[3].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callEWListApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[4].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callAMCSILVERListApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[5].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callAMCGOLDListApi(0, 1, false);
    }

    else if (this.selectedCategory === this.category[6].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callAMCP2PListApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[7].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callNSDListApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[8].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callSCHLabourApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[9].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callSCHPartApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[10].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callESTLabourApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[11].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callESTPartApi(0, 1, false);
    }
    else if (this.selectedCategory === this.category[12].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callUserPositionApi(0, 1, false);
    } 
    else if (this.selectedCategory === this.category[13].viewValue) {
      this.hideAllTables();
      this.spinnerService.show();
      this.callPROTECTPLUSHListApi(0, 1, false);
    }
  }

  hideAllTables() {

    document.getElementById('download_option').style.display = 'none';
    document.getElementById('probing_table').style.display = 'none';
    document.getElementById('nsd_table').style.display = 'none';
    document.getElementById('ew_table').style.display = 'none';
    document.getElementById('war_table').style.display = 'none';
    document.getElementById('amc_gold_table').style.display = 'none';
    document.getElementById('amc_silver_table').style.display = 'none';
    document.getElementById('amc_protectplus_table').style.display = 'none';
    document.getElementById('amc_p2p_table').style.display = 'none';
    document.getElementById('circular_table').style.display = 'none';
    document.getElementById('sch_labour_table').style.display = 'none';
    document.getElementById('sch_part_table').style.display = 'none';
    document.getElementById('est_labour_table').style.display = 'none';
    document.getElementById('est_part_table').style.display = 'none';
    document.getElementById('user_position_table').style.display = 'none';
    this.data = [];
    this.data_NSD = [];
    this.data_EW = [];
    this.data_WAR = [];
    this.data_AMC_SILVER = [];
    this.data_PROTECT_PLUS= [];
    this.data_AMC_P2P = [];
    this.data_CIRCULAR = [];
    this.data_SCH_LABOUR = [];
    this.data_SCH_PART = [];
    this.data_EST_LABOUR = [];
    this.data_EST_PART = [];
    this.data_USER_POSITION = [];
  }

  ngOnInit() {
    this.selectedCategory = "No Category choosen";
    this.hideAllTables();
    var token = localStorage.getItem('token');
    if (token == undefined || token === '') {
      this.router.navigate(['/login']);
      this.onChangeTable(this.config);

    }


  }
  //====================================Probing=========================================================  
  public rows: Array<any> = [];
  public columns: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'Complaint Code', name: 'complaint_code' },
    { title: 'Complaint Description', name: 'complaint_desc' },
    { title: 'Probing Question', name: 'probing_question' },
    { title: 'Order', name: 'order' }
  ];
  public page: number = 1;
  public itemsPerPage: number = 100;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;


  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage(page: any, data: Array<any> = this.data): Array<any> {

    let start = (page.page - 1) * page.itemsPerPage;

    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);

  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name].toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);

    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;

  }

  public onCellClick(data: any): any {
    // console.log(data);
  }

  callGetProbingListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'prob_question', this.baseAPI.probingGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callGetProbingListApi(0, noOfRecords, true);
      }
      else {
        this.spinnerService.hide();
        document.getElementById('probing_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data = jsonObj.result;
        this.onChangeTable(this.config);
      }



    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //====================================NSD=======================================================  
  public rows_NSD: Array<any> = [];

  public columns_NSD: Array<any> = [
    { title: 'Id', name: 'ROW_ID' },
    { title: 'Serial No', name: 'SERIAL_NUMBER' },
    { title: 'PPL', name: 'PPL' },
    { title: 'PL', name: 'PL' },
    { title: 'Service Type', name: 'SERVICE_TYPE' },
    { title: 'KFS', name: 'KFS' },
    { title: 'Range Start KM', name: 'RANGE_START_KM' },
    { title: 'Range End KM', name: 'RANGE_END_KM' },
    { title: 'DNP', name: 'DNP' },
    { title: 'Range Start Date', name: 'RANGE_START_DATE' },
    { title: 'Range End Date', name: 'RANGE_END_DATE' },
  ];
  public page_NSD: number = 1;
  public itemsPerPage_NSD: number = 100;
  public maxSize_NSD: number = 5;
  public numPages_NSD: number = 1;
  public length_NSD: number = 0;


  public config_NSD: any = {
    paging: true,
    sorting: { columns: this.columns_NSD },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_NSD(page_NSD: any, data_NSD: Array<any> = this.data_NSD): Array<any> {

    let start = (page_NSD.page - 1) * page_NSD.itemsPerPage;

    let end = page_NSD.itemsPerPage > -1 ? (start + page_NSD.itemsPerPage) : data_NSD.length;
    return data_NSD.slice(start, end);

  }

  public changeSort_NSD(data_NSD: any, config_NSD: any): any {
    if (!config_NSD.sorting) {
      return data_NSD;
    }

    let columns_NSD = this.config_NSD.sorting.columns_NSD || [];
    let columnName_NSD: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_NSD.length; i++) {
      if (columns_NSD[i].sort !== '' && columns_NSD[i].sort !== false) {
        columnName_NSD = columns_NSD[i].name;
        sort = columns_NSD[i].sort;
      }
    }

    if (!columnName_NSD) {
      return data_NSD;
    }

    // simple sorting
    return data_NSD.sort((previous: any, current: any) => {
      if (previous[columnName_NSD] > current[columnName_NSD]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_NSD] < current[columnName_NSD]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_NSD(data_NSD: any, config_NSD: any): any {
    let filteredData: Array<any> = data_NSD;
    this.columns_NSD.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_NSD.filtering) {
      return filteredData;
    }

    if (config_NSD.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_NSD.filtering.columnName].match(this.config_NSD.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_NSD.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_NSD.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_NSD(config_NSD: any, page: any = { page: this.page_NSD, itemsPerPage: this.itemsPerPage_NSD }): any {


    if (config_NSD.filtering) {
      Object.assign(this.config_NSD.filtering, config_NSD.filtering);
    }

    if (config_NSD.sorting) {
      Object.assign(this.config_NSD.sorting, config_NSD.sorting);
    }

    let filteredData = this.changeFilter_NSD(this.data_NSD, this.config_NSD);
    let sortedData = this.changeSort_NSD(filteredData, this.config_NSD);

    this.rows_NSD = page && config_NSD.paging ? this.changePage_NSD(page, sortedData) : sortedData;
    this.length_NSD = sortedData.length;

  }

  public onCellClick_NSD(data: any): any {
    //console.log(data);
  }

  callNSDListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'nsd', this.baseAPI.nsdGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callNSDListApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('nsd_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_NSD = jsonObj.result;
        this.onChangeTable_NSD(this.config_NSD);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //====================================EW=========================================================  
  public rows_EW: Array<any> = [];

  public columns_EW: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'PL', name: 'PL' },
    { title: 'Year', name: 'YEAR' },
    { title: 'MAX_KMS', name: 'MAX_KMS' },
    { title: '0_90_DAYS', name: '0_90_DAYS' },
    { title: '91_180_DAYS', name: '91_180_DAYS' },
    { title: '180_ABOVE_DAYS', name: '180_ABOVE_DAYS' },
    { title: 'Remarks', name: 'REMARKS' }

  ];
  public page_EW: number = 1;
  public itemsPerPage_EW: number = 100;
  public maxSize_EW: number = 5;
  public numPages_EW: number = 1;
  public length_EW: number = 0;


  public config_EW: any = {
    paging: true,
    sorting: { columns: this.columns_EW },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_EW(page_EW: any, data_EW: Array<any> = this.data_EW): Array<any> {

    let start = (page_EW.page - 1) * page_EW.itemsPerPage;

    let end = page_EW.itemsPerPage > -1 ? (start + page_EW.itemsPerPage) : data_EW.length;
    return data_EW.slice(start, end);

  }

  public changeSort_EW(data_EW: any, config_EW: any): any {
    if (!config_EW.sorting) {
      return data_EW;
    }

    let columns_EW = this.config_EW.sorting.columns_EW || [];
    let columnName_EW: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_EW.length; i++) {
      if (columns_EW[i].sort !== '' && columns_EW[i].sort !== false) {
        columnName_EW = columns_EW[i].name;
        sort = columns_EW[i].sort;
      }
    }

    if (!columnName_EW) {
      return data_EW;
    }

    // simple sorting
    return data_EW.sort((previous: any, current: any) => {
      if (previous[columnName_EW] > current[columnName_EW]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_EW] < current[columnName_EW]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_EW(data_EW: any, config_EW: any): any {
    let filteredData: Array<any> = data_EW;
    this.columns_EW.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_EW.filtering) {
      return filteredData;
    }

    if (config_EW.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_EW.filtering.columnName].match(this.config_EW.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_EW.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_EW.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_EW(config_EW: any, page: any = { page: this.page_EW, itemsPerPage: this.itemsPerPage_EW }): any {


    if (config_EW.filtering) {
      Object.assign(this.config_EW.filtering, config_EW.filtering);
    }

    if (config_EW.sorting) {
      Object.assign(this.config_EW.sorting, config_EW.sorting);
    }

    let filteredData = this.changeFilter_EW(this.data_EW, this.config_EW);
    let sortedData = this.changeSort_EW(filteredData, this.config_EW);

    this.rows_EW = page && config_EW.paging ? this.changePage_EW(page, sortedData) : sortedData;
    this.length_EW = sortedData.length;

  }

  public onCellClick_EW(data: any): any {
    // console.log(data);
  }

  callEWListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'ew', this.baseAPI.ewGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callEWListApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('ew_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_EW = jsonObj.result;
        this.onChangeTable_EW(this.config_EW);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  //====================================WAR=========================================================  
  public rows_WAR: Array<any> = [];

  public columns_WAR: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PL', name: 'PL' },
    { title: 'PPL', name: 'PPL' },
    { title: 'WKM', name: 'WKM' },
    { title: 'WDAY', name: 'WDAY' }

  ];
  public page_WAR: number = 1;
  public itemsPerPage_WAR: number = 100;
  public maxSize_WAR: number = 5;
  public numPages_WAR: number = 1;
  public length_WAR: number = 0;


  public config_WAR: any = {
    paging: true,
    sorting: { columns: this.columns_WAR },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_WAR(page_WAR: any, data_WAR: Array<any> = this.data_WAR): Array<any> {

    let start = (page_WAR.page - 1) * page_WAR.itemsPerPage;

    let end = page_WAR.itemsPerPage > -1 ? (start + page_WAR.itemsPerPage) : data_WAR.length;
    return data_WAR.slice(start, end);

  }

  public changeSort_WAR(data_WAR: any, config_WAR: any): any {
    if (!config_WAR.sorting) {
      return data_WAR;
    }

    let columns_WAR = this.config_WAR.sorting.columns_WAR || [];
    let columnName_WAR: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_WAR.length; i++) {
      if (columns_WAR[i].sort !== '' && columns_WAR[i].sort !== false) {
        columnName_WAR = columns_WAR[i].name;
        sort = columns_WAR[i].sort;
      }
    }

    if (!columnName_WAR) {
      return data_WAR;
    }

    // simple sorting
    return data_WAR.sort((previous: any, current: any) => {
      if (previous[columnName_WAR] > current[columnName_WAR]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_WAR] < current[columnName_WAR]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_WAR(data_WAR: any, config_WAR: any): any {
    let filteredData: Array<any> = data_WAR;
    this.columns_WAR.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_WAR.filtering) {
      return filteredData;
    }

    if (config_WAR.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_WAR.filtering.columnName].match(this.config_WAR.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_WAR.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_WAR.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_WAR(config_WAR: any, page: any = { page: this.page_WAR, itemsPerPage: this.itemsPerPage_WAR }): any {


    if (config_WAR.filtering) {
      Object.assign(this.config_WAR.filtering, config_WAR.filtering);
    }

    if (config_WAR.sorting) {
      Object.assign(this.config_WAR.sorting, config_WAR.sorting);
    }

    let filteredData = this.changeFilter_WAR(this.data_WAR, this.config_WAR);
    let sortedData = this.changeSort_WAR(filteredData, this.config_WAR);

    this.rows_WAR = page && config_WAR.paging ? this.changePage_WAR(page, sortedData) : sortedData;
    this.length_WAR = sortedData.length;

  }

  public onCellClick_WAR(data: any): any {
    //console.log(data);
  }

  callWARListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'warranty', this.baseAPI.warrantyGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callWARListApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('war_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_WAR = jsonObj.result;
        this.onChangeTable_WAR(this.config_WAR);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //====================================AMC Gold===============================================  
  public rows_AMC_GOLD: Array<any> = [];

  public columns_AMC_GOLD: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'PL', name: 'PL' },
    { title: 'Product', name: 'PRODUCT' },
    { title: 'Eligible Services', name: 'ELIGIBLE_SERVICES' },
    { title: 'Validity_KMS', name: 'VALIDITY_KMS' },
    { title: 'Validity_YEARS', name: 'VALIDITY_YEARS' },
    { title: 'Value', name: 'VALUE' },
    { title: 'Remarks', name: 'REMARKS' }


  ];
  public page_AMC_GOLD: number = 1;
  public itemsPerPage_AMC_GOLD: number = 100;
  public maxSize_AMC_GOLD: number = 5;
  public numPages_AMC_GOLD: number = 1;
  public length_AMC_GOLD: number = 0;


  public config_AMC_GOLD: any = {
    paging: true,
    sorting: { columns: this.columns_AMC_GOLD },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_AMC_GOLD(page_AMC_GOLD: any, data_AMC_GOLD: Array<any> = this.data_AMC_GOLD): Array<any> {

    let start = (page_AMC_GOLD.page - 1) * page_AMC_GOLD.itemsPerPage;

    let end = page_AMC_GOLD.itemsPerPage > -1 ? (start + page_AMC_GOLD.itemsPerPage) : data_AMC_GOLD.length;
    return data_AMC_GOLD.slice(start, end);

  }

  public changeSort_AMC_GOLD(data_AMC_GOLD: any, config_AMC_GOLD: any): any {
    if (!config_AMC_GOLD.sorting) {
      return data_AMC_GOLD;
    }

    let columns_AMC_GOLD = this.config_AMC_GOLD.sorting.columns_AMC_GOLD || [];
    let columnName_AMC_GOLD: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_AMC_GOLD.length; i++) {
      if (columns_AMC_GOLD[i].sort !== '' && columns_AMC_GOLD[i].sort !== false) {
        columnName_AMC_GOLD = columns_AMC_GOLD[i].name;
        sort = columns_AMC_GOLD[i].sort;
      }
    }

    if (!columnName_AMC_GOLD) {
      return data_AMC_GOLD;
    }

    // simple sorting
    return data_AMC_GOLD.sort((previous: any, current: any) => {
      if (previous[columnName_AMC_GOLD] > current[columnName_AMC_GOLD]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_AMC_GOLD] < current[columnName_AMC_GOLD]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_AMC_GOLD(data_AMC_GOLD: any, config_AMC_GOLD: any): any {
    let filteredData: Array<any> = data_AMC_GOLD;
    this.columns_AMC_GOLD.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_AMC_GOLD.filtering) {
      return filteredData;
    }

    if (config_AMC_GOLD.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_AMC_GOLD.filtering.columnName].match(this.config_AMC_GOLD.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_AMC_GOLD.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_AMC_GOLD.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_AMC_GOLD(config_AMC_GOLD: any, page: any = { page: this.page_AMC_GOLD, itemsPerPage: this.itemsPerPage_AMC_GOLD }): any {


    if (config_AMC_GOLD.filtering) {
      Object.assign(this.config_AMC_GOLD.filtering, config_AMC_GOLD.filtering);
    }

    if (config_AMC_GOLD.sorting) {
      Object.assign(this.config_AMC_GOLD.sorting, config_AMC_GOLD.sorting);
    }

    let filteredData = this.changeFilter_AMC_GOLD(this.data_AMC_GOLD, this.config_AMC_GOLD);
    let sortedData = this.changeSort_AMC_GOLD(filteredData, this.config_AMC_GOLD);

    this.rows_AMC_GOLD = page && config_AMC_GOLD.paging ? this.changePage_AMC_GOLD(page, sortedData) : sortedData;
    this.length_AMC_GOLD = sortedData.length;

  }

  public onCellClick_AMC_GOLD(data: any): any {
    //console.log(data);
  }

  callAMCGOLDListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'amc_gold', this.baseAPI.amcGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callAMCGOLDListApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('amc_gold_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_AMC_GOLD = jsonObj.result;
        this.onChangeTable_AMC_GOLD(this.config_AMC_GOLD);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //====================================AMC Silver=============================================  
  public rows_AMC_SILVER: Array<any> = [];

  public columns_AMC_SILVER: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'PL', name: 'PL' },
    { title: 'Product', name: 'PRODUCT' },
    { title: 'Eligible Services', name: 'ELIGIBLE_SERVICES' },
    { title: 'Validity_KMS', name: 'VALIDITY_KMS' },
    { title: 'Validity_YEARS', name: 'VALIDITY_YEARS' },
    { title: 'Rank', name: 'RANK' },
    { title: 'KMS_MIN', name: 'KMS_MIN' },
    { title: 'KMS_MAX', name: 'KMS_MAX' },
    { title: 'AGE_MIN', name: 'AGE_MIN' },
    { title: 'AGE_MAX', name: 'AGE_MAX' },
    { title: 'Value', name: 'VALUE' },
    { title: 'Remarks', name: 'REMARKS' }


  ];
  public page_AMC_SILVER: number = 1;
  public itemsPerPage_AMC_SILVER: number = 100;
  public maxSize_AMC_SILVER: number = 5;
  public numPages_AMC_SILVER: number = 1;
  public length_AMC_SILVER: number = 0;


  public config_AMC_SILVER: any = {
    paging: true,
    sorting: { columns: this.columns_AMC_SILVER },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_AMC_SILVER(page_AMC_SILVER: any, data_AMC_SILVER: Array<any> = this.data_AMC_SILVER): Array<any> {

    let start = (page_AMC_SILVER.page - 1) * page_AMC_SILVER.itemsPerPage;

    let end = page_AMC_SILVER.itemsPerPage > -1 ? (start + page_AMC_SILVER.itemsPerPage) : data_AMC_SILVER.length;
    return data_AMC_SILVER.slice(start, end);

  }

  public changeSort_AMC_SILVER(data_AMC_SILVER: any, config_AMC_SILVER: any): any {
    if (!config_AMC_SILVER.sorting) {
      return data_AMC_SILVER;
    }

    let columns_AMC_SILVER = this.config_AMC_SILVER.sorting.columns_AMC_SILVER || [];
    let columnName_AMC_SILVER: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_AMC_SILVER.length; i++) {
      if (columns_AMC_SILVER[i].sort !== '' && columns_AMC_SILVER[i].sort !== false) {
        columnName_AMC_SILVER = columns_AMC_SILVER[i].name;
        sort = columns_AMC_SILVER[i].sort;
      }
    }

    if (!columnName_AMC_SILVER) {
      return data_AMC_SILVER;
    }

    // simple sorting
    return data_AMC_SILVER.sort((previous: any, current: any) => {
      if (previous[columnName_AMC_SILVER] > current[columnName_AMC_SILVER]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_AMC_SILVER] < current[columnName_AMC_SILVER]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_AMC_SILVER(data_AMC_SILVER: any, config_AMC_SILVER: any): any {
    let filteredData: Array<any> = data_AMC_SILVER;
    this.columns_AMC_SILVER.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_AMC_SILVER.filtering) {
      return filteredData;
    }

    if (config_AMC_SILVER.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_AMC_SILVER.filtering.columnName].match(this.config_AMC_SILVER.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_AMC_SILVER.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_AMC_SILVER.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_AMC_SILVER(config_AMC_SILVER: any, page: any = { page: this.page_AMC_SILVER, itemsPerPage: this.itemsPerPage_AMC_SILVER }): any {


    if (config_AMC_SILVER.filtering) {
      Object.assign(this.config_AMC_SILVER.filtering, config_AMC_SILVER.filtering);
    }

    if (config_AMC_SILVER.sorting) {
      Object.assign(this.config_AMC_SILVER.sorting, config_AMC_SILVER.sorting);
    }

    let filteredData = this.changeFilter_AMC_SILVER(this.data_AMC_SILVER, this.config_AMC_SILVER);
    let sortedData = this.changeSort_AMC_SILVER(filteredData, this.config_AMC_SILVER);

    this.rows_AMC_SILVER = page && config_AMC_SILVER.paging ? this.changePage_AMC_SILVER(page, sortedData) : sortedData;
    this.length_AMC_SILVER = sortedData.length;

  }

  public onCellClick_AMC_SILVER(data: any): any {
    //console.log(data);
  }

  callAMCSILVERListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'amc_silver', this.baseAPI.amcGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callAMCSILVERListApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('amc_silver_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_AMC_SILVER = jsonObj.result;
        this.onChangeTable_AMC_SILVER(this.config_AMC_SILVER);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //===========================Protect Plus=============================================================
   
  public rows_PROTECT_PLUS: Array<any> = [];

  public columns_PROTECT_PLUS: Array<any> = [
    { title: 'Id ', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'PL', name: 'PL' },
    { title: 'Product', name: 'PRODUCT' },
    { title: 'Eligible Services', name: 'ELIGIBLE_SERVICES' },
    { title: 'Validity_KMS', name: 'VALIDITY_KMS' },
    { title: 'Validity_YEARS', name: 'VALIDITY_YEARS' },
    { title: 'Rank', name: 'RANK' },
    { title: 'KMS_MIN', name: 'KMS_MIN' },
    { title: 'KMS_MAX', name: 'KMS_MAX' },
    { title: 'AGE_MIN', name: 'AGE_MIN' },
    { title: 'AGE_MAX', name: 'AGE_MAX' },
    { title: 'Value', name: 'VALUE' },
	{ title: 'END_KMS', name: 'END_KMS' },
    { title: 'END_AGE_IN_YEARS', name: 'END_AGE_IN_YEARS' },
    { title: 'Remarks', name: 'REMARKS' }


  ];
  public page_PROTECT_PLUS: number = 1;
  public itemsPerPage_PROTECT_PLUS: number = 100;
  public maxSize_PROTECT_PLUS: number = 5;
  public numPages_PROTECT_PLUS: number = 1;
  public length_PROTECT_PLUS: number = 0;


  public config_PROTECT_PLUS: any = {
    paging: true,
    sorting: { columns: this.columns_PROTECT_PLUS },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_PROTECT_PLUS(page_PROTECT_PLUS: any, data_PROTECT_PLUS: Array<any> = this.data_PROTECT_PLUS): Array<any> {

    let start = (page_PROTECT_PLUS.page - 1) * page_PROTECT_PLUS.itemsPerPage;

    let end = page_PROTECT_PLUS.itemsPerPage > -1 ? (start + page_PROTECT_PLUS.itemsPerPage) : data_PROTECT_PLUS.length;
    return data_PROTECT_PLUS.slice(start, end);

  }

  public changeSort_PROTECT_PLUS(data_PROTECT_PLUS: any, config_PROTECT_PLUS: any): any {
    if (!config_PROTECT_PLUS.sorting) {
      return data_PROTECT_PLUS;
    }

    let columns_PROTECT_PLUS = this.config_PROTECT_PLUS.sorting.columns_PROTECT_PLUS || [];
    let columnName_PROTECT_PLUS: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_PROTECT_PLUS.length; i++) {
      if (columns_PROTECT_PLUS[i].sort !== '' && columns_PROTECT_PLUS[i].sort !== false) {
        columnName_PROTECT_PLUS = columns_PROTECT_PLUS[i].name;
        sort = columns_PROTECT_PLUS[i].sort;
      }
    }

    if (!columnName_PROTECT_PLUS) {
      return data_PROTECT_PLUS;
    }

    // simple sorting
    return data_PROTECT_PLUS.sort((previous: any, current: any) => {
      if (previous[columnName_PROTECT_PLUS] > current[columnName_PROTECT_PLUS]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_PROTECT_PLUS] < current[columnName_PROTECT_PLUS]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_PROTECT_PLUS(data_PROTECT_PLUS: any, config_PROTECT_PLUS: any): any {
    let filteredData: Array<any> = data_PROTECT_PLUS;
    this.columns_PROTECT_PLUS.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_PROTECT_PLUS.filtering) {
      return filteredData;
    }

    if (config_PROTECT_PLUS.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_PROTECT_PLUS.filtering.columnName].match(this.config_PROTECT_PLUS.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_PROTECT_PLUS.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_PROTECT_PLUS.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_PROTECT_PLUS(config_PROTECT_PLUS: any, page: any = { page: this.page_PROTECT_PLUS, itemsPerPage: this.itemsPerPage_PROTECT_PLUS }): any {


    if (config_PROTECT_PLUS.filtering) {
      Object.assign(this.config_PROTECT_PLUS.filtering, config_PROTECT_PLUS.filtering);
    }

    if (config_PROTECT_PLUS.sorting) {
      Object.assign(this.config_PROTECT_PLUS.sorting, config_PROTECT_PLUS.sorting);
    }

    let filteredData = this.changeFilter_PROTECT_PLUS(this.data_PROTECT_PLUS, this.config_PROTECT_PLUS);
    let sortedData = this.changeSort_PROTECT_PLUS(filteredData, this.config_PROTECT_PLUS);

    this.rows_PROTECT_PLUS = page && config_PROTECT_PLUS.paging ? this.changePage_PROTECT_PLUS(page, sortedData) : sortedData;
    this.length_PROTECT_PLUS = sortedData.length;

  }

  public onCellClick_PROTECT_PLUS(data: any): any {
    //console.log(data);
  }
  callPROTECTPLUSHListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'amc_pplus', this.baseAPI.amcGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
		console.log(JSON.stringify(jsonObj));
        noOfRecords = jsonObj.total_results;
        this.callPROTECTPLUSHListApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('amc_protectplus_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_PROTECT_PLUS = jsonObj.result;
        this.onChangeTable_PROTECT_PLUS(this.config_PROTECT_PLUS);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  //====================================AMC P2P=================================================  
  public rows_AMC_P2P: Array<any> = [];

  public columns_AMC_P2P: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'PL', name: 'PL' },
    { title: 'Product', name: 'PRODUCT' },
    { title: 'Eligible Services', name: 'ELIGIBLE_SERVICES' },
    { title: 'Validity_KMS', name: 'VALIDITY_KMS' },
    { title: 'Validity_YEARS', name: 'VALIDITY_YEARS' },
    { title: 'Value', name: 'VALUE' },
    { title: 'Remarks', name: 'REMARKS' }


  ];
  public page_AMC_P2P: number = 1;
  public itemsPerPage_AMC_P2P: number = 100;
  public maxSize_AMC_P2P: number = 5;
  public numPages_AMC_P2P: number = 1;
  public length_AMC_P2P: number = 0;


  public config_AMC_P2P: any = {
    paging: true,
    sorting: { columns: this.columns_AMC_P2P },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_AMC_P2P(page_AMC_P2P: any, data_AMC_P2P: Array<any> = this.data_AMC_P2P): Array<any> {

    let start = (page_AMC_P2P.page - 1) * page_AMC_P2P.itemsPerPage;

    let end = page_AMC_P2P.itemsPerPage > -1 ? (start + page_AMC_P2P.itemsPerPage) : data_AMC_P2P.length;
    return data_AMC_P2P.slice(start, end);

  }

  public changeSort_AMC_P2P(data_AMC_P2P: any, config_AMC_P2P: any): any {
    if (!config_AMC_P2P.sorting) {
      return data_AMC_P2P;
    }

    let columns_AMC_P2P = this.config_AMC_P2P.sorting.columns_AMC_P2P || [];
    let columnName_AMC_P2P: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_AMC_P2P.length; i++) {
      if (columns_AMC_P2P[i].sort !== '' && columns_AMC_P2P[i].sort !== false) {
        columnName_AMC_P2P = columns_AMC_P2P[i].name;
        sort = columns_AMC_P2P[i].sort;
      }
    }

    if (!columnName_AMC_P2P) {
      return data_AMC_P2P;
    }

    // simple sorting
    return data_AMC_P2P.sort((previous: any, current: any) => {
      if (previous[columnName_AMC_P2P] > current[columnName_AMC_P2P]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_AMC_P2P] < current[columnName_AMC_P2P]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_AMC_P2P(data_AMC_P2P: any, config_AMC_P2P: any): any {
    let filteredData: Array<any> = data_AMC_P2P;
    this.columns_AMC_P2P.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_AMC_P2P.filtering) {
      return filteredData;
    }

    if (config_AMC_P2P.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_AMC_P2P.filtering.columnName].match(this.config_AMC_P2P.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_AMC_P2P.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_AMC_P2P.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_AMC_P2P(config_AMC_P2P: any, page: any = { page: this.page_AMC_P2P, itemsPerPage: this.itemsPerPage_AMC_P2P }): any {


    if (config_AMC_P2P.filtering) {
      Object.assign(this.config_AMC_P2P.filtering, config_AMC_P2P.filtering);
    }

    if (config_AMC_P2P.sorting) {
      Object.assign(this.config_AMC_P2P.sorting, config_AMC_P2P.sorting);
    }

    let filteredData = this.changeFilter_AMC_P2P(this.data_AMC_P2P, this.config_AMC_P2P);
    let sortedData = this.changeSort_AMC_P2P(filteredData, this.config_AMC_P2P);

    this.rows_AMC_P2P = page && config_AMC_P2P.paging ? this.changePage_AMC_P2P(page, sortedData) : sortedData;
    this.length_AMC_P2P = sortedData.length;

  }

  public onCellClick_AMC_P2P(data: any): any {
    //console.log(data);
  }

  callAMCP2PListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'amc_p2p', this.baseAPI.amcGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callAMCP2PListApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('amc_p2p_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_AMC_P2P = jsonObj.result;
        this.onChangeTable_AMC_P2P(this.config_AMC_P2P);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //===================================Circular table=============================================== 
  public rows_CIRCULAR: Array<any> = [];

  public columns_CIRCULAR: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'Category', name: 'Category' },
    { title: 'Circular_Name', name: 'Circular_Name' },
    { title: 'Circular_Description', name: 'Circular_description' },
    { title: 'PDF_URL', name: 'PDF_URL' },
    { title: 'Active flag', name: 'ACTIVE_FLAG' },
    { title: 'Order', name: 'Order' },
    { title: 'Upload pdf', name: 'upload_button' },
    { title: 'Delete Circular', name: 'delete_button' }

  ];
  public page_CIRCULAR: number = 1;
  public itemsPerPage_CIRCULAR: number = 100;
  public maxSize_CIRCULAR: number = 5;
  public numPages_CIRCULAR: number = 1;
  public length_CIRCULAR: number = 0;


  public config_CIRCULAR: any = {
    paging: true,
    sorting: { columns: this.columns_CIRCULAR },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_CIRCULAR(page_CIRCULAR: any, data_CIRCULAR: Array<any> = this.data_CIRCULAR): Array<any> {

    let start = (page_CIRCULAR.page - 1) * page_CIRCULAR.itemsPerPage;

    let end = page_CIRCULAR.itemsPerPage > -1 ? (start + page_CIRCULAR.itemsPerPage) : data_CIRCULAR.length;
    return data_CIRCULAR.slice(start, end);

  }

  public changeSort_CIRCULAR(data_CIRCULAR: any, config_CIRCULAR: any): any {
    if (!config_CIRCULAR.sorting) {
      return data_CIRCULAR;
    }

    let columns_CIRCULAR = this.config_CIRCULAR.sorting.columns_CIRCULAR || [];
    let columnName_CIRCULAR: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_CIRCULAR.length; i++) {
      if (columns_CIRCULAR[i].sort !== '' && columns_CIRCULAR[i].sort !== false) {
        columnName_CIRCULAR = columns_CIRCULAR[i].name;
        sort = columns_CIRCULAR[i].sort;
      }
    }

    if (!columnName_CIRCULAR) {
      return data_CIRCULAR;
    }

    // simple sorting
    return data_CIRCULAR.sort((previous: any, current: any) => {
      if (previous[columnName_CIRCULAR] > current[columnName_CIRCULAR]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_CIRCULAR] < current[columnName_CIRCULAR]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_CIRCULAR(data_CIRCULAR: any, config_CIRCULAR: any): any {
    let filteredData: Array<any> = data_CIRCULAR;
    this.columns_CIRCULAR.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_CIRCULAR.filtering) {
      return filteredData;
    }

    if (config_CIRCULAR.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_CIRCULAR.filtering.columnName].match(this.config_CIRCULAR.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_CIRCULAR.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_CIRCULAR.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_CIRCULAR(config_CIRCULAR: any, page: any = { page: this.page_CIRCULAR, itemsPerPage: this.itemsPerPage_CIRCULAR }): any {


    if (config_CIRCULAR.filtering) {
      Object.assign(this.config_CIRCULAR.filtering, config_CIRCULAR.filtering);
    }

    if (config_CIRCULAR.sorting) {
      Object.assign(this.config_CIRCULAR.sorting, config_CIRCULAR.sorting);
    }

    let filteredData = this.changeFilter_CIRCULAR(this.data_CIRCULAR, this.config_CIRCULAR);
    let sortedData = this.changeSort_CIRCULAR(filteredData, this.config_CIRCULAR);

    this.rows_CIRCULAR = page && config_CIRCULAR.paging ? this.changePage_CIRCULAR(page, sortedData) : sortedData;
    this.length_CIRCULAR = sortedData.length;

  }

  public onCellClick_CIRCULAR(data: any): any {
    if (data.column == 'upload_button') {
      var obj = Object.assign(data);
      // console.log(obj);
      this.selectedCircularId = obj.row.id;
      this.selectedCircularName = obj.row.Circular_Name;
      var modal = document.getElementById('myModal');
      modal.style.display = "block";

    }
    else if (data.column == 'delete_button') {

      var obj = Object.assign(data);
      this.selectedCircularId = obj.row.id;

      this.spinnerService.show();
      this.deleteCircular();
    }
  }


  deleteCircular() {
    let formData: FormData = new FormData();
    formData.append('ROW_ID', this.selectedCircularId + '');
    this.baseAPI.callDeleteCircularApi(this.baseAPI.deleteCircularDataURL, formData).then(data => {

      this.callCircularListApi(0, 1, false);

    }, (err) => {
      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }


  callCircularListApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'circulars', this.baseAPI.circularDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callCircularListApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('circular_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));

        this.data_CIRCULAR = jsonObj.result;
        this.onChangeTable_CIRCULAR(this.config_CIRCULAR);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  downloadCircularListApi(startIndex, noOfRecords, shouldLoadData) {
    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'circulars', this.baseAPI.circularExcelData).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.downloadCircularListApi(0, noOfRecords, true);
        //console.log(JSON.stringify(data));
      }
      else {
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_CIRCULAR_DOWNLOAD = jsonObj.result;
        // console.log(JSON.stringify(data));
        this.excel.exportAsExcelFile(this.data_CIRCULAR_DOWNLOAD, 'CircularMaster');
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  // ======================Circular Dialog================================================
  closeDialog() {
    var modal = document.getElementById('myModal');
    modal.style.display = "none";
  }
  getFiles(event) {
    this.files = event.target.files;
    if (this.files != undefined && this.files != null) {
      var fileSize = this.files[0].size;
      if (fileSize >= 5242880) {
        alert('Please select a file below 5MB');
        this.refreshPage();
      }
    }

  }
  refreshPage() {
    this.files = null;
    this.form.nativeElement.reset();
  }
  uploadPdf() {
    var modal = document.getElementById('myModal');
    modal.style.display = "none";
    this.spinnerService.show();
    this.callUploadCircularPdfApi();


  }
  callUploadCircularPdfApi() {
    if (this.files != undefined && this.files != null) {
      let formData: FormData = new FormData();
      formData.append('files', this.files[0]);

      formData.append('ROW_ID', this.selectedCircularId + '');
      formData.append('CIRCULAR_NAME', this.selectedCircularName + '');
      this.baseAPI.callUploadDataApi(formData, this.baseAPI.uploadCircularPdfURL).then(data => {
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        var msg = jsonObj.message;
        alert(msg);

        this.spinnerService.show();
        this.callCircularListApi(0, 1, false);
      }, (err) => {
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(err));

        alert(jsonObj.msg);

      });
    }
    else {
      alert('Choose file to upload');
    }
  }
  //====================================Sechdule Labour=========================================  
  public rows_SCH_LABOUR: Array<any> = [];

  public columns_SCH_LABOUR: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'PL', name: 'PL' },
    { title: 'Service_Type_Group', name: 'Service_Type_Group' },
    { title: 'Service_type', name: 'Service_type' },
    { title: 'KMs_Period', name: 'KMs/Period' },
    { title: 'Job_Code', name: 'Job_Code' },
    { title: 'Job_Code_Type', name: 'Job_Code_Type' },
    { title: 'Job_Description', name: 'Job_Description' },
    { title: 'Billing_Category', name: 'Billing_Category' },
    { title: 'No_of_Jobs', name: 'No_of_Jobs' },
    { title: 'Billing_Hours', name: 'Billing_Hours' },
    { title: 'Active', name: 'Active' },
    { title: 'Status', name: 'Status' }


  ];
  public page_SCH_LABOUR: number = 1;
  public itemsPerPage_SCH_LABOUR: number = 100;
  public maxSize_SCH_LABOUR: number = 5;
  public numPages_SCH_LABOUR: number = 1;
  public length_SCH_LABOUR: number = 0;


  public config_SCH_LABOUR: any = {
    paging: true,
    sorting: { columns: this.columns_SCH_LABOUR },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_SCH_LABOUR(page_SCH_LABOUR: any, data_SCH_LABOUR: Array<any> = this.data_SCH_LABOUR): Array<any> {

    let start = (page_SCH_LABOUR.page - 1) * page_SCH_LABOUR.itemsPerPage;

    let end = page_SCH_LABOUR.itemsPerPage > -1 ? (start + page_SCH_LABOUR.itemsPerPage) : data_SCH_LABOUR.length;
    return data_SCH_LABOUR.slice(start, end);

  }

  public changeSort_SCH_LABOUR(data_SCH_LABOUR: any, config_SCH_LABOUR: any): any {
    if (!config_SCH_LABOUR.sorting) {
      return data_SCH_LABOUR;
    }

    let columns_SCH_LABOUR = this.config_SCH_LABOUR.sorting.columns_SCH_LABOUR || [];
    let columnName_SCH_LABOUR: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_SCH_LABOUR.length; i++) {
      if (columns_SCH_LABOUR[i].sort !== '' && columns_SCH_LABOUR[i].sort !== false) {
        columnName_SCH_LABOUR = columns_SCH_LABOUR[i].name;
        sort = columns_SCH_LABOUR[i].sort;
      }
    }

    if (!columnName_SCH_LABOUR) {
      return data_SCH_LABOUR;
    }

    // simple sorting
    return data_SCH_LABOUR.sort((previous: any, current: any) => {
      if (previous[columnName_SCH_LABOUR] > current[columnName_SCH_LABOUR]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_SCH_LABOUR] < current[columnName_SCH_LABOUR]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_SCH_LABOUR(data_SCH_LABOUR: any, config_SCH_LABOUR: any): any {
    let filteredData: Array<any> = data_SCH_LABOUR;
    this.columns_SCH_LABOUR.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_SCH_LABOUR.filtering) {
      return filteredData;
    }

    if (config_SCH_LABOUR.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_SCH_LABOUR.filtering.columnName].match(this.config_SCH_LABOUR.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_SCH_LABOUR.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_SCH_LABOUR.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_SCH_LABOUR(config_SCH_LABOUR: any, page: any = { page: this.page_SCH_LABOUR, itemsPerPage: this.itemsPerPage_SCH_LABOUR }): any {


    if (config_SCH_LABOUR.filtering) {
      Object.assign(this.config_SCH_LABOUR.filtering, config_SCH_LABOUR.filtering);
    }

    if (config_SCH_LABOUR.sorting) {
      Object.assign(this.config_SCH_LABOUR.sorting, config_SCH_LABOUR.sorting);
    }

    let filteredData = this.changeFilter_SCH_LABOUR(this.data_SCH_LABOUR, this.config_SCH_LABOUR);
    let sortedData = this.changeSort_SCH_LABOUR(filteredData, this.config_SCH_LABOUR);

    this.rows_SCH_LABOUR = page && config_SCH_LABOUR.paging ? this.changePage_SCH_LABOUR(page, sortedData) : sortedData;
    this.length_SCH_LABOUR = sortedData.length;

  }

  public onCellClick_SCH_LABOUR(data: any): any {
    //  console.log(data);
  }

  callSCHLabourApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'sche_service_labour', this.baseAPI.schServiceGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callSCHLabourApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('sch_labour_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_SCH_LABOUR = jsonObj.result;
        this.onChangeTable_SCH_LABOUR(this.config_SCH_LABOUR);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //====================================Sechdule Part==========================================  
  public rows_SCH_PART: Array<any> = [];

  public columns_SCH_PART: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'PL', name: 'PL' },
    { title: 'Service_Type_Group', name: 'Service_Type_Group' },
    { title: 'Service_type', name: 'Service_type' },
    { title: 'KMsPeriod', name: 'KMs/Period' },
    { title: 'Part_Number', name: 'Part_Number' },
    { title: 'Part_Description', name: 'Part_Description' },
    { title: 'Part_Type', name: 'Part_Type' },
    { title: 'UOM', name: 'UOM' },
    { title: 'Qty', name: 'Qty' },
    { title: 'Rate', name: 'Rate' },
    { title: 'Amount', name: 'Amount' },
    { title: 'Active', name: 'Active' }



  ];
  public page_SCH_PART: number = 1;
  public itemsPerPage_SCH_PART: number = 100;
  public maxSize_SCH_PART: number = 5;
  public numPages_SCH_PART: number = 1;
  public length_SCH_PART: number = 0;


  public config_SCH_PART: any = {
    paging: true,
    sorting: { columns: this.columns_SCH_PART },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_SCH_PART(page_SCH_PART: any, data_SCH_PART: Array<any> = this.data_SCH_PART): Array<any> {

    let start = (page_SCH_PART.page - 1) * page_SCH_PART.itemsPerPage;

    let end = page_SCH_PART.itemsPerPage > -1 ? (start + page_SCH_PART.itemsPerPage) : data_SCH_PART.length;
    return data_SCH_PART.slice(start, end);

  }

  public changeSort_SCH_PART(data_SCH_PART: any, config_SCH_PART: any): any {
    if (!config_SCH_PART.sorting) {
      return data_SCH_PART;
    }

    let columns_SCH_PART = this.config_SCH_PART.sorting.columns_SCH_PART || [];
    let columnName_SCH_PART: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_SCH_PART.length; i++) {
      if (columns_SCH_PART[i].sort !== '' && columns_SCH_PART[i].sort !== false) {
        columnName_SCH_PART = columns_SCH_PART[i].name;
        sort = columns_SCH_PART[i].sort;
      }
    }

    if (!columnName_SCH_PART) {
      return data_SCH_PART;
    }

    // simple sorting
    return data_SCH_PART.sort((previous: any, current: any) => {
      if (previous[columnName_SCH_PART] > current[columnName_SCH_PART]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_SCH_PART] < current[columnName_SCH_PART]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_SCH_PART(data_SCH_PART: any, config_SCH_PART: any): any {
    let filteredData: Array<any> = data_SCH_PART;
    this.columns_SCH_PART.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_SCH_PART.filtering) {
      return filteredData;
    }

    if (config_SCH_PART.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_SCH_PART.filtering.columnName].match(this.config_SCH_PART.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_SCH_PART.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_SCH_PART.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_SCH_PART(config_SCH_PART: any, page: any = { page: this.page_SCH_PART, itemsPerPage: this.itemsPerPage_SCH_PART }): any {


    if (config_SCH_PART.filtering) {
      Object.assign(this.config_SCH_PART.filtering, config_SCH_PART.filtering);
    }

    if (config_SCH_PART.sorting) {
      Object.assign(this.config_SCH_PART.sorting, config_SCH_PART.sorting);
    }

    let filteredData = this.changeFilter_SCH_PART(this.data_SCH_PART, this.config_SCH_PART);
    let sortedData = this.changeSort_SCH_PART(filteredData, this.config_SCH_PART);

    this.rows_SCH_PART = page && config_SCH_PART.paging ? this.changePage_SCH_PART(page, sortedData) : sortedData;
    this.length_SCH_PART = sortedData.length;

  }

  public onCellClick_SCH_PART(data: any): any {
    //console.log(data);
  }

  callSCHPartApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'sche_service_parts', this.baseAPI.schServiceGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callSCHPartApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('sch_part_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_SCH_PART = jsonObj.result;
        this.onChangeTable_SCH_PART(this.config_SCH_PART);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

  //====================================Job Est Labour==========================================  
  public rows_EST_LABOUR: Array<any> = [];

  public columns_EST_LABOUR: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'Labour_Code', name: 'labour_code' },
    { title: 'Labour_Description', name: 'labour_desp' },
    { title: 'Default_Qty', name: 'default_qty' },
    { title: 'Billing_Hours', name: 'billing_hours' },
    { title: 'Labour_Type', name: 'labour_type' },
    { title: 'Status', name: 'Status' },
    { title: 'Active', name: 'Active' }



  ];
  public page_EST_LABOUR: number = 1;
  public itemsPerPage_EST_LABOUR: number = 100;
  public maxSize_EST_LABOUR: number = 5;
  public numPages_EST_LABOUR: number = 1;
  public length_EST_LABOUR: number = 0;


  public config_EST_LABOUR: any = {
    paging: true,
    sorting: { columns: this.columns_EST_LABOUR },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_EST_LABOUR(page_EST_LABOUR: any, data_EST_LABOUR: Array<any> = this.data_EST_LABOUR): Array<any> {

    let start = (page_EST_LABOUR.page - 1) * page_EST_LABOUR.itemsPerPage;

    let end = page_EST_LABOUR.itemsPerPage > -1 ? (start + page_EST_LABOUR.itemsPerPage) : data_EST_LABOUR.length;
    return data_EST_LABOUR.slice(start, end);

  }

  public changeSort_EST_LABOUR(data_EST_LABOUR: any, config_EST_LABOUR: any): any {
    if (!config_EST_LABOUR.sorting) {
      return data_EST_LABOUR;
    }

    let columns_EST_LABOUR = this.config_EST_LABOUR.sorting.columns_EST_LABOUR || [];
    let columnName_EST_LABOUR: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_EST_LABOUR.length; i++) {
      if (columns_EST_LABOUR[i].sort !== '' && columns_EST_LABOUR[i].sort !== false) {
        columnName_EST_LABOUR = columns_EST_LABOUR[i].name;
        sort = columns_EST_LABOUR[i].sort;
      }
    }

    if (!columnName_EST_LABOUR) {
      return data_EST_LABOUR;
    }

    // simple sorting
    return data_EST_LABOUR.sort((previous: any, current: any) => {
      if (previous[columnName_EST_LABOUR] > current[columnName_EST_LABOUR]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_EST_LABOUR] < current[columnName_EST_LABOUR]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_EST_LABOUR(data_EST_LABOUR: any, config_EST_LABOUR: any): any {
    let filteredData: Array<any> = data_EST_LABOUR;
    this.columns_EST_LABOUR.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_EST_LABOUR.filtering) {
      return filteredData;
    }

    if (config_EST_LABOUR.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_EST_LABOUR.filtering.columnName].match(this.config_EST_LABOUR.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_EST_LABOUR.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_EST_LABOUR.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_EST_LABOUR(config_EST_LABOUR: any, page: any = { page: this.page_EST_LABOUR, itemsPerPage: this.itemsPerPage_EST_LABOUR }): any {


    if (config_EST_LABOUR.filtering) {
      Object.assign(this.config_EST_LABOUR.filtering, config_EST_LABOUR.filtering);
    }

    if (config_EST_LABOUR.sorting) {
      Object.assign(this.config_EST_LABOUR.sorting, config_EST_LABOUR.sorting);
    }

    let filteredData = this.changeFilter_EST_LABOUR(this.data_EST_LABOUR, this.config_EST_LABOUR);
    let sortedData = this.changeSort_EST_LABOUR(filteredData, this.config_EST_LABOUR);

    this.rows_EST_LABOUR = page && config_EST_LABOUR.paging ? this.changePage_EST_LABOUR(page, sortedData) : sortedData;
    this.length_EST_LABOUR = sortedData.length;

  }

  public onCellClick_EST_LABOUR(data: any): any {
    // console.log(data);
  }

  callESTLabourApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'std_estimate_labour', this.baseAPI.jobEstimateGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callESTLabourApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('est_labour_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        this.data_EST_LABOUR = jsonObj.result;
        this.onChangeTable_EST_LABOUR(this.config_EST_LABOUR);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //====================================Job Est Parts==================================  
  public rows_EST_PART: Array<any> = [];

  public columns_EST_PART: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'PPL', name: 'PPL' },
    { title: 'Part_Number', name: 'part_number' },
    { title: 'Part_Description', name: 'part_desc' },
    { title: 'Default_Qty', name: 'default_qty' },
    { title: 'UOM', name: 'UOM' },
    { title: 'UMRP', name: 'UMRP' },
    { title: 'Active', name: 'Active' }
  ];

  public page_EST_PART: number = 1;
  public itemsPerPage_EST_PART: number = 100;
  public maxSize_EST_PART: number = 5;
  public numPages_EST_PART: number = 1;
  public length_EST_PART: number = 0;


  public config_EST_PART: any = {
    paging: true,
    sorting: { columns: this.columns_EST_PART },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_EST_PART(page_EST_PART: any, data_EST_PART: Array<any> = this.data_EST_PART): Array<any> {

    let start = (page_EST_PART.page - 1) * page_EST_PART.itemsPerPage;

    let end = page_EST_PART.itemsPerPage > -1 ? (start + page_EST_PART.itemsPerPage) : data_EST_PART.length;
    return data_EST_PART.slice(start, end);

  }

  public changeSort_EST_PART(data_EST_PART: any, config_EST_PART: any): any {
    if (!config_EST_PART.sorting) {
      return data_EST_PART;
    }

    let columns_EST_PART = this.config_EST_PART.sorting.columns_EST_PART || [];
    let columnName_EST_PART: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_EST_PART.length; i++) {
      if (columns_EST_PART[i].sort !== '' && columns_EST_PART[i].sort !== false) {
        columnName_EST_PART = columns_EST_PART[i].name;
        sort = columns_EST_PART[i].sort;
      }
    }

    if (!columnName_EST_PART) {
      return data_EST_PART;
    }

    // simple sorting
    return data_EST_PART.sort((previous: any, current: any) => {
      if (previous[columnName_EST_PART] > current[columnName_EST_PART]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_EST_PART] < current[columnName_EST_PART]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_EST_PART(data_EST_PART: any, config_EST_PART: any): any {
    let filteredData: Array<any> = data_EST_PART;
    this.columns_EST_PART.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_EST_PART.filtering) {
      return filteredData;
    }

    if (config_EST_PART.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_EST_PART.filtering.columnName].match(this.config_EST_PART.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_EST_PART.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_EST_PART.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_EST_PART(config_EST_PART: any, page: any = { page: this.page_EST_PART, itemsPerPage: this.itemsPerPage_EST_PART }): any {


    if (config_EST_PART.filtering) {
      Object.assign(this.config_EST_PART.filtering, config_EST_PART.filtering);
    }

    if (config_EST_PART.sorting) {
      Object.assign(this.config_EST_PART.sorting, config_EST_PART.sorting);
    }

    let filteredData = this.changeFilter_EST_PART(this.data_EST_PART, this.config_EST_PART);
    let sortedData = this.changeSort_EST_PART(filteredData, this.config_EST_PART);

    this.rows_EST_PART = page && config_EST_PART.paging ? this.changePage_EST_PART(page, sortedData) : sortedData;
    this.length_EST_PART = sortedData.length;

  }

  public onCellClick_EST_PART(data: any): any {
    //console.log(data);
  }

  callESTPartApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'std_estimate_parts', this.baseAPI.jobEstimateGetDataURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callESTPartApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('est_part_table').style.display = 'block';
        document.getElementById('download_option').style.display = 'block';
        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));
        //console.log(JSON.stringify(data));
        this.data_EST_PART = jsonObj.result;
        this.onChangeTable_EST_PART(this.config_EST_PART);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  //==============================User Position============================================
  public rows_USER_POSITION: Array<any> = [];

  public columns_USER_POSITION: Array<any> = [
    { title: 'Id', name: 'id' },
    { title: 'Position Type', name: 'position_type' },
    { title: 'Portal Status', name: 'is_portal' },
    { title: 'Portal Action', name: 'portal_button' },
    { title: 'App Status', name: 'is_app' },
    { title: 'App Action', name: 'app_button' }
  ];

  public page_USER_POSITION: number = 1;
  public itemsPerPage_USER_POSITION: number = 100;
  public maxSize_USER_POSITION: number = 5;
  public numPages_USER_POSITION: number = 1;
  public length_USER_POSITION: number = 0;


  public config_USER_POSITION: any = {
    paging: true,
    sorting: { columns: this.columns_USER_POSITION },
    filtering: { filterString: '' },
    className: ['table-striped', 'table-bordered']
  };


  public changePage_USER_POSITION(page_USER_POSITION: any, data_USER_POSITION: Array<any> = this.data_USER_POSITION): Array<any> {

    let start = (page_USER_POSITION.page - 1) * page_USER_POSITION.itemsPerPage;

    let end = page_USER_POSITION.itemsPerPage > -1 ? (start + page_USER_POSITION.itemsPerPage) : data_USER_POSITION.length;
    return data_USER_POSITION.slice(start, end);

  }

  public changeSort_USER_POSITION(data_USER_POSITION: any, config_USER_POSITION: any): any {
    if (!config_USER_POSITION.sorting) {
      return data_USER_POSITION;
    }

    let columns_USER_POSITION = this.config_USER_POSITION.sorting.columns_USER_POSITION || [];
    let columnName_USER_POSITION: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns_USER_POSITION.length; i++) {
      if (columns_USER_POSITION[i].sort !== '' && columns_USER_POSITION[i].sort !== false) {
        columnName_USER_POSITION = columns_USER_POSITION[i].name;
        sort = columns_USER_POSITION[i].sort;
      }
    }

    if (!columnName_USER_POSITION) {
      return data_USER_POSITION;
    }

    // simple sorting
    return data_USER_POSITION.sort((previous: any, current: any) => {
      if (previous[columnName_USER_POSITION] > current[columnName_USER_POSITION]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName_USER_POSITION] < current[columnName_USER_POSITION]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter_USER_POSITION(data_USER_POSITION: any, config_USER_POSITION: any): any {
    let filteredData: Array<any> = data_USER_POSITION;
    this.columns_USER_POSITION.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config_USER_POSITION.filtering) {
      return filteredData;
    }

    if (config_USER_POSITION.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config_USER_POSITION.filtering.columnName].match(this.config_USER_POSITION.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns_USER_POSITION.forEach((column: any) => {
        if (item[column.name].toString().match(this.config_USER_POSITION.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChangeTable_USER_POSITION(config_USER_POSITION: any, page: any = { page: this.page_USER_POSITION, itemsPerPage: this.itemsPerPage_USER_POSITION }): any {


    if (config_USER_POSITION.filtering) {
      Object.assign(this.config_USER_POSITION.filtering, config_USER_POSITION.filtering);
    }

    if (config_USER_POSITION.sorting) {
      Object.assign(this.config_USER_POSITION.sorting, config_USER_POSITION.sorting);
    }

    let filteredData = this.changeFilter_USER_POSITION(this.data_USER_POSITION, this.config_USER_POSITION);
    let sortedData = this.changeSort_USER_POSITION(filteredData, this.config_USER_POSITION);

    this.rows_USER_POSITION = page && config_USER_POSITION.paging ? this.changePage_USER_POSITION(page, sortedData) : sortedData;
    this.length_USER_POSITION = sortedData.length;

  }

  public onCellClick_USER_POSITION(data: any): any {
    if (data.column == 'portal_button') {
      var obj = Object.assign(data);

      var userPostionId = obj.row.id;
      var position_type = obj.row.position_type;
      var position_Status = obj.row.is_portal;
      var updatePostionStatus = '';
      if (position_Status === 'N') {
        updatePostionStatus = 'Y';
      }
      else {
        updatePostionStatus = 'N';
      }
      this.updateUserPosition(userPostionId, 'portal', position_type, updatePostionStatus);

    }
    else if (data.column == 'app_button') {
      var obj = Object.assign(data);

      var userPostionId = obj.row.id;
      var position_type = obj.row.position_type;
      var position_Status = obj.row.is_app;
      var updatePostionStatus = '';
      if (position_Status === 'N') {
        updatePostionStatus = 'Y';
      }
      else {
        updatePostionStatus = 'N';

      }
      this.spinnerService.show();
      this.updateUserPosition(userPostionId, 'app', position_type, updatePostionStatus);
    }
  }

  callUserPositionApi(startIndex, noOfRecords, shouldLoadData) {

    this.baseAPI.callGetDataApi(startIndex, noOfRecords, 'sa_positions', this.baseAPI.getUserPositionURL).then(data => {

      if (!shouldLoadData) {
        var jsonObj = JSON.parse(JSON.stringify(data));
        noOfRecords = jsonObj.total_results;
        this.callUserPositionApi(0, noOfRecords, true);
      }
      else {

        document.getElementById('user_position_table').style.display = 'block';

        this.spinnerService.hide();
        var jsonObj = JSON.parse(JSON.stringify(data));

        this.data_USER_POSITION = jsonObj.result;
        this.onChangeTable_USER_POSITION(this.config_USER_POSITION);
      }

    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }
  updateUserPosition(userPositionId, type, positionType, positionStatus) {
   
    this.spinnerService.show();
    this.baseAPI.callUpdateUserPositionApi(userPositionId, type, positionType, positionStatus).then(data => {

     this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(data));

      var msg = jsonObj.msg;
      alert(msg);
      this.callUserPositionApi(0, 1, false);


    }, (err) => {

      this.spinnerService.hide();
      var jsonObj = JSON.parse(JSON.stringify(err));
      var message = jsonObj.msg;
      if (message != undefined) {
        alert(message);
      }
      else {
        alert('Please try again');
      }
    });
  }

}






// WEBPACK FOOTER //
// ./src/app/view-master/view-master.component.ts